import { Box, Grid, Paper, Tabs, Tab } from "@mui/material";
import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../../context";

import { useTheme } from "@mui/material/styles";

const tabStyle = {
  textTransform: "capitalize",
  fontWeight: "bold",
  borderRadius: "10px",
};

const BeautyNav = () => {
  const theme = useTheme();
  const auth = useAuth();
  const user = auth?.user?.user;
  const { t } = useTranslation();
  const [value, setValue] = useState("/beauty");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(newValue);
  };

  useEffect(() => {
    const path = location.pathname;
    const validPaths = [
      "beauty",
      "/beauty/new-patient",
      "/beauty/type",
      "/beauty/add-procedure",
      "/beauty/view-procedure",
    ];
    if (validPaths.includes(path)) {
      setValue(path);
    } else {
      setValue("/beauty");
    }
  }, [location.pathname]);

  return (
    <Grid container maxWidth="xl">
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ padding: "10px 0px", boxShadow: "0px 0px 0px" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              ml: "5px",
              "& .MuiTabs-indicator": { display: "none" },
              "& .MuiTab-root": { minWidth: "120px" },
            }}
          >
            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/beauty" ? theme.palette.primary.main : "white",
                color: value === "/beauty" ? "white" : "black",
              }}
              label={t("reception.dashboard", "Dashboard")}
              value="/beauty"
              component={NavLink}
              to="/beauty"
            />

            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/beauty/new-patient"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/beauty/new-patient" ? "white" : "black",
              }}
              label={t("reception.newPatient")}
              value="/beauty/new-patient"
              component={NavLink}
              to="/beauty/new-patient"
            />

            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/beauty/type"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/beauty/type" ? "white" : "black",
              }}
              label={t("call_center.procedureType")}
              value="/beauty/type"
              component={NavLink}
              to="/beauty/type"
            />

            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/beauty/add-procedure"
                    ? theme.palette.primary.main
                    : "white",
                color: value === "/beauty/add-procedure" ? "white" : "black",
              }}
              label={t("call_center.addProcedure")}
              value="/beauty/add-procedure"
              component={NavLink}
              to="/beauty/add-procedure"
            />

            <Tab
              style={{
                ...tabStyle,
                backgroundColor:
                  value === "/beauty/view-procedure"
                    ? theme.palette.primary.main
                    : "transparent",
                color: value === "/beauty/view-procedure" ? "white" : "black",
              }}
              label={t("call_center.viewProcedure")}
              value="/beauty/view-procedure"
              component={NavLink}
              to="/beauty/view-procedure"
            />
          </Tabs>
        </Paper>
      </Box>
      <Outlet />
    </Grid>
  );
};

export default BeautyNav;
